// extracted by mini-css-extract-plugin
module.exports = {"profileContainer":"Signup_profileContainer__bt8LR","avatarName":"Signup_avatarName__2ZU0S"};